export class Popup {
    constructor() {
        const popup = document.querySelector('[data-popup]')
        if (!popup) {
            return
        }

        const key = 'perjes-popup-' + (popup.dataset.popup || '1')

        const seen = () => {
            try {
                if (window.localStorage.getItem(key)) {
                    return true
                }
            } catch (e) {}
            return document.cookie.split(';').some((part) => part.trim().indexOf(key + '=') === 0)
        }

        const remember = () => {
            try {
                window.localStorage.setItem(key, '1')
            } catch (e) {}
            document.cookie = key + '=1;path=/;max-age=31536000;SameSite=Lax'
        }

        if (seen()) {
            return
        }

        popup.hidden = false
        document.body.classList.add('has-popup')

        const close = () => {
            remember()
            popup.hidden = true
            document.body.classList.remove('has-popup')
            document.removeEventListener('keydown', onKey)
        }

        const onKey = (event) => {
            if (event.key === 'Escape') {
                close()
            }
        }

        popup.querySelectorAll('[data-popup-close]').forEach((button) => {
            button.addEventListener('click', close)
        })
        popup.querySelectorAll('a').forEach((link) => {
            link.addEventListener('click', remember)
        })
        document.addEventListener('keydown', onKey)
    }
}

export class HeroVideo {
    constructor() {
        document.querySelectorAll('video[autoplay]').forEach((video) => {
            video.muted = true
            video.defaultMuted = true
            video.playsInline = true
            video.setAttribute('playsinline', '')
            video.setAttribute('webkit-playsinline', '')
            const play = video.play()
            if (play && typeof play.catch === 'function') {
                play.catch(() => {})
            }
        })
    }
}
